import { Card, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    height: '100%',
    alignItems: 'center',
    padding: theme.spacing(1, 1, 2, 1),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(1, 1, 2, 1)
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1, 1, 2, 5),
      alignItems: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 1, 2, 5),
      alignItems: 'start'
    },
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  typography: {
    color: '#ffffff'
  }
}));

const Center = props => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <Typography className={classes.typography} variant="body2">
        Termos e condições
      </Typography>
      <Typography className={classes.typography} variant="body2">
        Politica de privacidade
      </Typography>
    </Card>
  );
};

export default Center;
